import { Component, computed, input } from '@angular/core';
import { TelephoneLinkComponent } from '../../../../../../shared/components/telephone-link/telephone-link.component';
import { MmrService } from '../../../../services/mmr.service';

@Component({
  selector: 'app-unknown',
  imports: [TelephoneLinkComponent],
  templateUrl: './unknown.component.html',
  styleUrl: './unknown.component.scss',
})
export class UnknownComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => ({
    postCode: this.mmrService.planClaimsDetails.claims.value()?.addressInformation?.postalCode,
    claimType: this.claimType(),
  }));

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
